import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import PublicFullLayout from 'src/layouts/public-full';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/404'));
const DigitalMenuPage = lazy(() => import('src/pages/companion/menu-page'));
// ----------------------------------------------------------------------

export const publicRoutes = [
  {
    path: 'ps',
    element: (
      <PublicFullLayout>
        <Outlet />
      </PublicFullLayout>
    ),
    children: [
      { path: '404', element: <Page404 /> },
      {
        path: 'menu',
        element: <DigitalMenuPage />,
      },
    ],
  },
];
